"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaders = exports.filterObject = void 0;

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @todo: please update
 * @param {*} headers 
 * @param {*} extraHeaders 
 * @param {*} allowedExtraHeaders 
 * @returns 
 */
const getHeaders = (headers, extraHeaders, allowedExtraHeaders) => {
  if (!extraHeaders) return headers; //If no extra headers, return default ones

  const finalHeaders = _objectSpread({}, headers);

  for (const key in extraHeaders) {
    if (allowedExtraHeaders.includes(key)) finalHeaders[key] = extraHeaders[key];
  }

  return finalHeaders;
};
/**
 * @todo: please update
 * @param {*} data 
 * @param {*} requestedFields 
 * @returns 
 */


exports.getHeaders = getHeaders;

const filterObject = (data, requestedFields) => {
  if (requestedFields.length === 0) return data; // If no requested fields specified, then return the complete response
  else {
    const filteredData = {};
    requestedFields.forEach(field => {
      if (data[field]) filteredData[field] = data[field];
    });
    return filteredData;
  }
};

exports.filterObject = filterObject;